// 대시보드 - API 콘텐츠 리스트 템플릿
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { palette } from "../../../../assets/styles/Palette";
import { Button } from "../../../../assets/styles/ButtonStyle";
import MoleculeHeader from "../../../Global/components/molecules/MoleculeHeader";
import { Body2, Sub2 } from "../../../../assets/styles/Typography";
import { useAtom } from "jotai";
import {
  IS_LOGGED_IN,
  AUTODISPLAY_DISPLAY_LIST,
  AUTODISPLAY_CONTENT_LIST,
  CUSTOMER_ID,
  CUSTOMER_NAME,
  CUSTOMER_DETAIL,
} from "../../../AtomStates";
import OrganismApiDashboardContentList from "../organisms/OrganismApiDashboardContentList";

import {
  getDisplayListOnServer,
  getDisplayListCustomerOnServer,
  getViewApiListOnServer,
  getViewCustomListOnServer,
  getViewApiListCustomerOnServer,
  getViewCustomListCustomerOnServer,
  getUserMemberType,
  getUserInfo,
  getCustomerDetailOnServer,
  createDisplayOnServer,
  updateDisplayOnServer,
  updateCustomerOnServer,
} from "../../../../utils/indexedDB";
import AutodisplayApiSelectedPopup from "../molecules/AutodisplayApiSelectedPopup";
import { TabWrapType3, TabButtonType3 } from "../../../../assets/styles/BusinessAnalysisStyle";
import OrganismDashboardDisplayList from "../organisms/OrganismDashboardDisplayList";
import PopupWrap from "../../../../assets/styles/Popup";

const TemplateApiContentsList = ({ onBack, onCreateContent }) => {
  const [activeTab, setActiveTab] = useState("content");
  const [isLoggedIn] = useAtom(IS_LOGGED_IN);
  const [, setCustomerId] = useAtom(CUSTOMER_ID);
  const [customerName, setCustomerName] = useAtom(CUSTOMER_NAME);
  const [customerDetail, setCustomerDetail] = useAtom(CUSTOMER_DETAIL);
  const [displayList, setDisplayList] = useAtom(AUTODISPLAY_DISPLAY_LIST);
  const [contentList, setContentList] = useAtom(AUTODISPLAY_CONTENT_LIST);
  const [activateCount, setActivateCount] = useState(0);
  const [showArrangePopup, setShowArrangePopup] = useState(false);
  const [showDeviceSelectPopup, setShowDeviceSelectPopup] = useState(false);
  const [showCustomerPopup, setShowCustomerPopup] = useState(false);
  const [companyName, setCompanyName] = useState("");
  const [address, setAddress] = useState("");
  const [companyInfo, setCompanyInfo] = useState("");

  const fetchCustomerDetail = async () => {
    const customerIdFromStorage = sessionStorage.getItem("customerId") || "";
    setCustomerId(customerIdFromStorage);
    if (customerIdFromStorage !== "") {
      try {
        const customerDetailResponse = await getCustomerDetailOnServer(
          customerIdFromStorage,
          isLoggedIn
        );
        if (customerDetailResponse) {
          setCustomerDetail(customerDetailResponse);
          setCustomerName(customerDetailResponse.companyName);
        }
      } catch (error) {
        console.error("고객사 정보를 불러오는 중 오류가 발생했습니다:", error);
      }
    }
  };

  const fetchLists = async () => {
    if (!isLoggedIn) return;
    try {
      let response;
      const accessToken = sessionStorage.getItem("accessToken");
      const memberType = await getUserMemberType(accessToken);
      const customerIdFromStorage = sessionStorage.getItem("customerId") || "";

      if (customerIdFromStorage === "" && memberType.member_type === 21) {
        response = await getDisplayListOnServer(10, 1, isLoggedIn);
        setDisplayList(response.data);
      } else {
        response = await getDisplayListCustomerOnServer(
          customerIdFromStorage,
          999,
          1,
          isLoggedIn
        );
        setDisplayList(response.data);
      }

      let viewList;
      let viewListCustom;

      if (customerIdFromStorage === "") {
        viewList = await getViewApiListOnServer(10, 1, isLoggedIn);
        viewListCustom = await getViewCustomListOnServer(10, 1, isLoggedIn);
      } else {
        viewList = await getViewApiListCustomerOnServer(
          customerIdFromStorage,
          999,
          1,
          isLoggedIn
        );
        viewListCustom = await getViewCustomListCustomerOnServer(
          customerIdFromStorage,
          999,
          1,
          isLoggedIn
        );
      }

      const mergedList = [
        ...(viewList?.data || []),
        ...(viewListCustom?.data || []),
      ];
      mergedList.sort((a, b) => (b.timestamp || 0) - (a.timestamp || 0));
      setContentList(mergedList);

      const totalActivate = (viewList?.activate_count || 0) + (viewListCustom?.activate_count || 0);
      setActivateCount(totalActivate);
    } catch (error) {
      console.error("리스트 로딩 중 오류:", error);
    }
  };

  const fetchCompanyName = async () => {
    const accessToken = sessionStorage.getItem("accessToken");
    if (sessionStorage.getItem("customerId") === "") {
      const userInfo = await getUserInfo(accessToken);
      setCustomerName(userInfo.organization_name);
    }
  };

  useEffect(() => {
    fetchCustomerDetail();
    fetchLists();
    fetchCompanyName();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn]);

  const handleAutoDisplaySelect = () => {
    setShowDeviceSelectPopup(false);
  };

  const handleAutoDisplayClose = () => {
    setShowDeviceSelectPopup(false);
  };

  const handleSaveNewDisplay = async (displayData) => {
    try {
      const customerIdFromStorage = sessionStorage.getItem("customerId") || "";
      if (customerIdFromStorage !== "") {
        displayData.customer = customerIdFromStorage;
      }
      const newDisplayId = await createDisplayOnServer(isLoggedIn);
      if (!newDisplayId) throw new Error("디스플레이 ID 생성에 실패했습니다.");
      await updateDisplayOnServer(newDisplayId, displayData);
      await fetchLists();
    } catch (error) {
      console.error("새 디스플레이 저장 실패:", error);
      throw error;
    }
  };

  const handleCustomerSubmit = async () => {
    try {
      const customerIdFromStorage = sessionStorage.getItem("customerId") || "";
      if (!customerIdFromStorage) {
        setShowCustomerPopup(false);
        return;
      }
      const data = {
        companyName: companyName,
        address: address,
        companyInfo: companyInfo,
      };
      await updateCustomerOnServer(customerIdFromStorage, data);
      setCustomerDetail((prev) => ({ ...prev, ...data }));
    } catch (error) {
      console.error("고객사 등록에 실패했습니다:", error);
    } finally {
      setShowCustomerPopup(false);
    }
  };

  return (
    <DashboardContainer>
      <MoleculeHeader />

      <MainContent>
        <TopSection>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <CompanyInfo>
              <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <CompanyName>{customerDetail?.companyName || customerName}</CompanyName>
                <button
                  style={{
                    display: "flex",
                    alignItems: "center",
                    background: "#f7f8fa",
                    border: "none",
                    borderRadius: "8px",
                    padding: "8px 16px",
                    color: "#666",
                    fontSize: "14px",
                    fontWeight: "500",
                    fontFamily: "Pretendard",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setShowCustomerPopup(true);
                    setCompanyName(customerDetail?.companyName || "");
                    setAddress(customerDetail?.address || "");
                    setCompanyInfo(customerDetail?.companyInfo || "");
                  }}
                >
                  <EditIcon />
                  고객사 정보
                </button>
              </div>
            </CompanyInfo>
            <Body2 color="gray600" style={{ textAlign: "left" }}>
              {customerDetail?.address}
            </Body2>
          </div>
          <ButtonGroup>
            <StyledBackButton onClick={onBack}>
              <svg
                width={20}
                height={20}
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ flexShrink: 0 }}
              >
                <circle
                  cx="10.11"
                  cy="10.11"
                  r="7.11"
                  stroke="#256EF4"
                  strokeWidth="1.5"
                />
                <line
                  x1="9.89549"
                  y1="6.4099"
                  x2="9.89549"
                  y2="10.1839"
                  stroke="#256EF4"
                  strokeWidth="1.86911"
                  strokeLinecap="round"
                />
                <line
                  x1="11.8236"
                  y1="11.5456"
                  x2="9.92994"
                  y2="10.1967"
                  stroke="#256EF4"
                  strokeWidth="1.86911"
                  strokeLinecap="round"
                />
              </svg>
              <span>콘텐츠 편성하기</span>
            </StyledBackButton>
            <Button 
                Large
                Primary
                Fill
                style={{ display: "inline-flex", alignItems: "center" }}
                onClick={() => setShowDeviceSelectPopup(true)}
            >
                <svg
                width={20}
                height={20}
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ flexShrink: 0 }}
                >
                <path
                  d="M9.99935 4.16669V15.8334M4.16602 10H15.8327"
                  stroke="white"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span style={{ marginLeft: 4 }}>새 디스플레이</span>
            </Button>
            <Button
              Large
              Primary
              Fill
              onClick={onCreateContent}
              style={{ display: "inline-flex", alignItems: "center" }}
            >
              <svg
                width={20}
                height={20}
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ flexShrink: 0 }}
              >
                <path
                  d="M9.99935 4.16669V15.8334M4.16602 10H15.8327"
                  stroke="white"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span style={{ marginLeft: 4 }}>새 콘텐츠</span>
            </Button>
          </ButtonGroup>
        </TopSection>

        {/* 통계 섹션 */}
        {/* <StatsSection>
          <StatsGrid>
            <StatCard>
              <StatHeader>
                <Body2 color="gray600">생성 완료 콘텐츠</Body2>
              </StatHeader>
              <StatValue>{contentList.length} 건</StatValue>
            </StatCard>
            <StatCard>
              <StatHeader>
                <Body2 color="gray600">활성화 콘텐츠</Body2>
              </StatHeader>
              <StatValue>{activateCount || 0} 건</StatValue>
            </StatCard>
            <StatCard>
              <StatHeader>
                <Body2 color="gray600">등록 디스플레이</Body2>
              </StatHeader>
              <StatValue>{displayList.length} 건</StatValue>
            </StatCard>
            <StatCard>
              <StatHeader>
                <Body2 color="gray600">멤버십</Body2>
              </StatHeader>
              <StatValue>Custom</StatValue>
            </StatCard>
          </StatsGrid>
        </StatsSection> */}

        <TableSection>
          <TabContainer>
            <TabWrapType3>
              <TabButtonType3
                isActive={activeTab === "content"}
                onClick={() => setActiveTab("content")}
              >
                콘텐츠 리스트 ({contentList.length})
              </TabButtonType3>
              <TabButtonType3
                isActive={activeTab === "display"}
                onClick={() => setActiveTab("display")}
              >
                디스플레이 리스트 ({displayList.length})
              </TabButtonType3>
            </TabWrapType3>
            {/* <CustomPopupSubtitle>
              콘텐츠 연결 주소: {" "}
              <ContentLink
                href={`${window.location.origin}/autodisplayViewApi`}
                target="_blank"
                rel="noopener noreferrer"
              >
                autodisplayViewApi
              </ContentLink>
            </CustomPopupSubtitle> */}
          </TabContainer>

          {activeTab === "content" ? (
            <OrganismApiDashboardContentList handleCreateContent={onCreateContent} />
          ) : (
            <OrganismDashboardDisplayList />
          )}
        </TableSection>
        {showDeviceSelectPopup && (
          <AutodisplayApiSelectedPopup
            onClose={handleAutoDisplayClose}
            onSelect={handleAutoDisplaySelect}
            onSaveNewDisplay={handleSaveNewDisplay}
            selectedEditDisplayId={null}
          />
        )}

        {showCustomerPopup && (
          <PopupWrap
            TitleFlex
            title="고객사 정보"
            buttonType="Fill"
            confirmText={"편집 내용 저장"}
            isModal={true}
            onCancel={() => setShowCustomerPopup(false)}
            onConfirm={handleCustomerSubmit}
            showTabs={true}
            eventState={false}
            creditRequestCustomPersona={100}
            isFormValid={!!companyName && !!address && (
              companyName !== (customerDetail?.companyName || "") ||
              address !== (customerDetail?.address || "") ||
              companyInfo !== (customerDetail?.companyInfo || "")
            )}
            body={
              <div>
                <>
                  <div className="column">
                    <Body2 color="gray700" align="left">고객사 명</Body2>
                    <PopupContent>
                      <InputBox>
                        <InputText
                          placeholder="입력해주세요."
                          value={companyName}
                          onChange={(e) => setCompanyName(e.target.value)}
                        />
                      </InputBox>
                    </PopupContent>
                  </div>
                  <div className="column">
                    <Body2 color="gray700" align="left">주소지</Body2>
                    <PopupContent>
                      <InputBox>
                        <InputText
                          placeholder="입력해주세요."
                          value={address}
                          onChange={(e) => setAddress(e.target.value)}
                        />
                      </InputBox>
                    </PopupContent>
                  </div>
                  <div className="column">
                    <Body2 color="gray700" align="left">고객사 관련 정보</Body2>
                    <PopupContent>
                      <InputBox2>
                        <InputTextArea
                          value={companyInfo}
                          onChange={(e) => setCompanyInfo(e.target.value)}
                          placeholder="입력해주세요."
                          rows={4}
                        />
                      </InputBox2>
                    </PopupContent>
                  </div>
                </>
              </div>
            }
          />
        )}
      </MainContent>
    </DashboardContainer>
  );
};

export default TemplateApiContentsList;

// 스타일
const DashboardContainer = styled.div`
  width: 100%;
  max-width: 2330px;
  margin: 0 auto;
  background: ${palette.white};
  min-height: 100vh;
`;

const MainContent = styled.main`
  max-width: 1240px;
  margin: 0 auto;
  padding: 145px 0;
  display: flex;
  flex-direction: column;
  gap: 72px;
`;

const TopSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
`;

const CompanyInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const CompanyName = styled.h2`
  font-family: poppins;
  font-weight: 700;
  font-size: 40px;
  color: #1e2124;
  margin: 0;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 16px;
`;

const SectionTitle = styled.h3`
  font-family: Pretendard;
  font-weight: 700;
  font-size: 16px;
  color: #696969;
  margin: 0;
  text-align: left;
`;

const TableSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const TabContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;
`;

const StyledBackButton = styled(Button).attrs({
  Large: true,
  PrimaryLightest: true,
  Fill: true,
})`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: ${palette.primary};

  &:hover {
    background: #e6f0ff !important;
  }
`;

const StatsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: -40px;
`;

const StatsGrid = styled.div`
  display: flex;
  gap: 20px;
`;

const StatCard = styled.div`
  flex: 1;
  background: ${palette.white};
  border: 1px solid #e0e4eb;
  border-radius: 10px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const StatHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const StatValue = styled.div`
  font-family: Poppins;
  font-weight: 700;
  font-size: 30px;
  color: #666666;
  text-align: left;
`;

const ContentLink = styled.a`
  color: ${palette.primary};
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: ${palette.primary}DD;
    text-decoration: underline;
  }

  &:visited {
    color: ${palette.primary};
  }
`;

const CustomPopupSubtitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${palette.gray600};
  margin: 0;
  margin-bottom: 12px;
`;

// 팝업 입력 폼 스타일 (PageApiDashBoard와 동일 톤)
const PopupContent = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
`;

const InputBox = styled.div`
  height: 56px;
  padding: 0 16px;
  background: rgba(179, 183, 186, 0.1);
  border-radius: 8px;
  display: flex;
  align-items: center;
  width: 100%;
`;

const InputBox2 = styled.div`
  height: 150px;
  padding: 0 16px;
  background: rgba(179, 183, 186, 0.1);
  border-radius: 8px;
  display: flex;
  align-items: flex-start;
  width: 100%;
`;

const InputText = styled.input`
  width: 100%;
  border: none;
  background: transparent;
  color: ${palette.gray800};
  font-size: 16px;
  font-family: Pretendard;
  font-weight: 400;
  line-height: 28.5px;
  outline: none;
  &::placeholder { color: ${palette.gray300}; }
`;

const InputTextArea = styled.textarea`
  width: 100%;
  border: none;
  background: transparent;
  color: ${palette.gray800};
  font-size: 16px;
  font-family: Pretendard;
  font-weight: 400;
  line-height: 28.5px;
  outline: none;
  padding-top: 16px;
  resize: vertical;
  &::placeholder { color: ${palette.gray300}; }
`;

const EditIcon = () => (
  <svg width="20" height="20" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M21.9124 4.12883C22.329 3.71227 23.0044 3.71227 23.4209 4.12883L28.7542 9.46216C28.9543 9.6622 29.0667 9.93351 29.0667 10.2164C29.0667 10.4993 28.9543 10.7706 28.7542 10.9707L16.7542 22.9707C16.5542 23.1707 16.2829 23.2831 16 23.2831H10.6667C10.0776 23.2831 9.6 22.8055 9.6 22.2164V16.8831C9.6 16.6002 9.71238 16.3289 9.91242 16.1288L21.9124 4.12883ZM22.6667 6.39157L20.1752 8.88307L24 12.7079L26.4915 10.2164L22.6667 6.39157ZM22.4915 14.2164L18.6667 10.3916L11.7333 17.3249V21.1497H15.5582L22.4915 14.2164ZM6.4 7.01641C6.25272 7.01641 6.13333 7.1358 6.13333 7.28307V26.4831C6.13333 26.6303 6.25272 26.7497 6.4 26.7497H25.6C25.7473 26.7497 25.8667 26.6303 25.8667 26.4831V17.1497C25.8667 16.5606 26.3442 16.0831 26.9333 16.0831C27.5224 16.0831 28 16.5606 28 17.1497V26.4831C28 27.8086 26.9255 28.8831 25.6 28.8831H6.4C5.07452 28.8831 4 27.8086 4 26.4831V7.28307C4 5.95759 5.07452 4.88307 6.4 4.88307H15.7323C16.3214 4.88307 16.799 5.36064 16.799 5.94974C16.799 6.53884 16.3214 7.01641 15.7323 7.01641H6.4Z" fill="#8A949E"/>
  </svg>
);